type AudioAssessmentState = {
    currentState: "pre-recording" | "countdown" | "recording" | "recording-success"
    isRecordingSuccessful: boolean
    isRecording: boolean
    preRecordingCountDownValue: number
    recordingTimeElapsed: number
    recordingError: boolean
    uploadState: "uploading" | "upload-success" | "upload-failure" | null
}
type AudioAssessmentAction =
    | { type: "update-current-state"; payload: AudioAssessmentState["currentState"] }
    | { type: "update-countdown-value"; payload: number }
    | { type: "update-recording-time-elapsed"; payload: number }
    | { type: "set-recording-error"; payload: boolean }
    | { type: "set-recording-successful"; payload: boolean }
    | { type: "set-upload-state"; payload: AudioAssessmentState["uploadState"] }
    | { type: "update-is-recording"; payload: boolean }
    | { type: "reset-state" }

export const initialState: AudioAssessmentState = {
    currentState: "pre-recording",
    isRecordingSuccessful: false,
    isRecording: false,
    preRecordingCountDownValue: 3,
    recordingTimeElapsed: 0,
    recordingError: false,
    uploadState: null,
}
export const audioAssessmentReducer = (
    state: AudioAssessmentState,
    action: AudioAssessmentAction
): AudioAssessmentState => {
    switch (action.type) {
        case "update-current-state": {
            if (action.payload === "countdown") {
                return {
                    ...state,
                    currentState: action.payload,
                    recordingTimeElapsed: 0,
                    uploadState: null,
                }
            }
            if (action.payload === "recording") {
                return {
                    ...state,
                    currentState: action.payload,
                    isRecording: true,
                }
            }
            return {
                ...state,
                currentState: action.payload,
            }
        }
        case "update-countdown-value": {
            return { ...state, preRecordingCountDownValue: action.payload }
        }
        case "update-is-recording": {
            return { ...state, isRecording: action.payload }
        }
        case "update-recording-time-elapsed": {
            return { ...state, recordingTimeElapsed: action.payload }
        }
        case "set-recording-error": {
            return { ...state, recordingError: action.payload }
        }
        case "set-recording-successful": {
            return {
                ...state,
                isRecordingSuccessful: action.payload,
                recordingError: false,
            }
        }
        case "set-upload-state": {
            return { ...state, uploadState: action.payload }
        }
        case "reset-state": {
            return initialState
        }
        default:
            return initialState
    }
}
